import { CommonModule } from '@angular/common';
import { Component, ElementRef } from '@angular/core';
import { FastCheckoutStepComponentDef } from '@df/checkout/fast/fast-checkout-step.component.def';
import { App } from '@df/core/app';
import { Logger } from '@df/core/service/logger';
import { ScrollToErrorService } from '@df/ui/form/scroll-to-error.service';
import { BasketKlarnaTrayComponent } from '../../basket/basket-klarna-tray.component';
import { GiftboxFormTrayComponent } from '../../basket/giftbox/giftbox-form-tray.component';
import { GiftboxIntroductionTrayComponent } from '../../basket/giftbox/giftbox-introduction-tray.component';
import { FastCheckoutShippingMethodsTrayComponent } from './fast-checkout-shipping-methods-tray.component';
import { MinibasketFastCheckoutFormComponent } from './minibasket-fast-checkout-form.component';

@Component({
    selector: 'minibasket-fast-checkout-step',
    templateUrl: './minibasket-fast-checkout-step.html',
    standalone: true,
    imports: [
        BasketKlarnaTrayComponent,
        CommonModule,
        FastCheckoutShippingMethodsTrayComponent,
        GiftboxFormTrayComponent,
        GiftboxIntroductionTrayComponent
    ]
})
export class MinibasketFastCheckoutStepComponent extends FastCheckoutStepComponentDef {
    constructor(
        public override checkoutFormComponent: MinibasketFastCheckoutFormComponent,
        ngEl: ElementRef,
        app: App,
        protected override logger: Logger,
        protected override scrollToErrorService: ScrollToErrorService
    ) {
        super(checkoutFormComponent, ngEl, app, logger, scrollToErrorService);
    }

    checkoutStepComponent: MinibasketFastCheckoutStepComponent = this;
}
